import { render, staticRenderFns } from "./WechatPage.vue?vue&type=template&id=ae0ec51c&scoped=true&"
import script from "./WechatPage.vue?vue&type=script&lang=js&"
export * from "./WechatPage.vue?vue&type=script&lang=js&"
import style0 from "./WechatPage.vue?vue&type=style&index=0&id=ae0ec51c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0ec51c",
  null
  
)

export default component.exports